import { BASE_URL } from "../configs";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from "./axios"

export async function getSubscriptions() {
    let url = `${BASE_URL}/api/subscription`;

    const res = await axiosInstance.get(url)
    return res.data.Data;
}

export async function getCurrentSubscription() {
    let url = `${BASE_URL}/api/subscription/current`;

    const res = await axiosInstance.get(url)
    return res.data.Data;
}

export async function createCheckoutSession(priceId) {
    let url = `${BASE_URL}/api/subscription/create-checkout-session`;

    const res = await axiosInstance.post(url, JSON.stringify({
        priceId
    }))
    return res.data.Data;
}

export async function unsubscribe() {
    let url = `${BASE_URL}/api/subscription/unsubscribe`;

    const res = await axiosInstance.post(url)
    return res.data.Data;
}